import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "reactstrap";

const stats = [
    { icon: "icon-bag-16", color: "primary", target: 150, suffix: "+", label: "Hizmet Verilen Firma" },
    { icon: "icon-single-02", color: "success", target: 8500, suffix: "+", label: "Muayene Edilen Çalışan" },
    { icon: "icon-book-bookmark", color: "warning", target: 320, suffix: "+", label: "Tamamlanan Eğitim" },
    { icon: "icon-trophy", color: "info", target: 10, suffix: "+", label: "Yıllık Deneyim" },
];

function useCountUp(target, duration = 2000, start = false) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        if (!start) return;
        let startTime = null;
        const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setCount(Math.round(eased * target));
            if (progress < 1) requestAnimationFrame(animate);
        };
        requestAnimationFrame(animate);
    }, [start, target, duration]);
    return count;
}

function StatCard({ icon, color, target, suffix, label }) {
    const [started, setStarted] = useState(false);
    const ref = useRef(null);
    const count = useCountUp(target, 2000, started);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => { if (entry.isIntersecting) setStarted(true); },
            { threshold: 0.3 }
        );
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return (
        <Col lg="3" md="6" className="text-center mb-4" ref={ref}>
            <div className="info">
                <div className={`icon icon-${color}`}>
                    <i className={`tim-icons ${icon}`} />
                </div>
                <h2 className="text-white" style={{ fontSize: "2.5rem", fontWeight: 700 }}>
                    {count}{suffix}
                </h2>
                <p className="text-white">{label}</p>
            </div>
        </Col>
    );
}

export default function StatsSection() {
    return (
        <section className="section section-lg">
            <Container>
                <Row className="justify-content-center mb-4">
                    <Col lg="8" className="text-center">
                        <h1 className="text-white">Rakamlarla Elit OSGB</h1>
                        <p className="text-white">Yıllar içinde edindiğimiz tecrübe ve müşteri memnuniyetiyle sektörde fark yaratıyoruz.</p>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    {stats.map((s, i) => <StatCard key={i} {...s} />)}
                </Row>
            </Container>
        </section>
    );
}
